import React, {useState} from 'react'
import PropTypes from 'prop-types'
import ContentBox from '../../../layout/component/ContentBox'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import LabelInput from '../../../form/component/LabelInput'
import Select from '../../../form/component/Select'
import Input from '../../../form/component/Input'
import {COUNTRY_CODE_LIST} from '../../../internationalization/const'
import currentUserHasAccess from '../../../../util/widget-helper'
import {SALES_ORDER_CUSTOMER_WIDGET} from '../../../process/ui-definition/process-ui'
import {lifecycle} from "recompose";

const SalesOrderCustomer = (
    {
        contact,
        salesOrderCustomer,
        callNumber,
        salutationList,
        changeCustomerContact,
        saveCustomerContact,
        hydrateContact,
        error
    }
) => {

    if (!currentUserHasAccess(SALES_ORDER_CUSTOMER_WIDGET)) {
        return null
    }

    const [readOnly, setReadOnly] = useState(true);

    const [isVisible, setIsVisible] = useState(false);

    const [validationMsgList, setValidationMsgList] = useState({})

    function validate(e) {
        if (e.value.length === 0 || !e.value.trim()) {
            setValidationMsgList({...validationMsgList, [e.name]: 'Is mandatory field, please fill before save'})
            return
        }
        if (validationMsgList[e.name]) {
            setValidationMsgList({...validationMsgList, [e.name]: null})
        }
    }

    function validateEmail(email) {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        const res = re.test(String(email).trim().toLowerCase());
        if (!res) {
            setValidationMsgList({...validationMsgList, email: 'email format not valid, please use a valid email'})
            return
        }
        if (validationMsgList.email) {
            setValidationMsgList({...validationMsgList, email: null})
        }
    }

    const toggleEditButtons = () => {
        setReadOnly(!readOnly)
        setIsVisible(!isVisible)
    }

    const ButtonGroup = () => {

        const btnStyle = {
            marginRight: '10px'
        }

        const onCancel = () => {
            toggleEditButtons()
            hydrateContact()
            setValidationMsgList({})
        }

        const onSave = () => {
            if (!checkValidationMsgList()) {
                return
            }
            saveCustomerContact()
            toggleEditButtons()
        }

        function checkValidationMsgList() {
            return Object.values(validationMsgList).every(currentValue => currentValue === null)
        }

        return (
            <React.Fragment>
                <button
                    className="btn btn-primary pull-right"
                    onClick={onSave}>
                    Save
                </button>
                <button
                    className="btn btn-default pull-right"
                    style={btnStyle}
                    onClick={onCancel}>
                    Cancel
                </button>
            </React.Fragment>
        )
    }

    return (
        <ContentBox title="Sales Order Customer ">
            <Row>
                <Column size={6}>
                    {error && (<span className="form-error">{error}</span>)}
                </Column>
                <Column size={6}>
                    {!isVisible &&
                    <button
                        className="btn btn-primary pull-right"
                        onClick={toggleEditButtons}>
                        <span className="fa fa-edit" aria-hidden="true"/>
                    </button>
                    }
                    {isVisible &&
                    <ButtonGroup/>
                    }
                </Column>
            </Row>
            <Row>
                <Column size={6}>
                    <LabelInput label="Salutation">
                        <Select object={contact}
                                name="gender"
                                readOnly={readOnly}
                                valueList={salutationList}
                                onChange={changeCustomerContact}
                        />
                    </LabelInput>
                </Column>
                <Column size={6}>

                </Column>
            </Row>
            <Row>
                <Column size={6}>
                    <LabelInput label="Firstname" groupAddOnIcon="fa fa-info">
                        <Input object={contact}
                               name="firstName"
                               readOnly={readOnly}
                               onChange={changeCustomerContact}
                               onBlur={e => validate(e.target)}
                        />
                    </LabelInput>
                    {validationMsgList.firstName && (
                        <span className="form-error">{validationMsgList.firstName}</span>)}
                </Column>
                <Column size={6}>
                    <LabelInput label="Lastname" groupAddOnIcon="fa fa-info">
                        <Input object={contact}
                               name="lastName"
                               readOnly={readOnly}
                               onChange={changeCustomerContact}
                               onBlur={e => validate(e.target)}
                        />
                    </LabelInput>
                    {validationMsgList.lastName && (
                        <span className="form-error">{validationMsgList.lastName}</span>)}
                </Column>
            </Row>
            <Row>
                <Column size={6}>
                    <LabelInput label="Street address" groupAddOnIcon="fa fa-info">
                        <Input object={contact}
                               name="streetAddress"
                               readOnly={readOnly}
                               onChange={changeCustomerContact}
                        />
                    </LabelInput>
                </Column>
                <Column size={6}>
                    <LabelInput label="Street address extension" groupAddOnIcon="fa fa-info">
                        <Input object={contact}
                               readOnly={readOnly}
                               name="streetAddressExtension"
                               onChange={changeCustomerContact}
                        />
                    </LabelInput>
                </Column>
            </Row>
            {
                salesOrderCustomer.countryCode === 'AT' && (
                    <Row>
                        <Column size={6}>
                            <LabelInput label="Staircase" groupAddOnIcon="fa fa-info">
                                <Input object={contact}
                                       name="staircase"
                                       readOnly={readOnly}
                                       onChange={changeCustomerContact}
                                />
                            </LabelInput>
                        </Column>
                        <Column size={6}>
                            <LabelInput label="Door" groupAddOnIcon="fa fa-info">
                                <Input object={contact}
                                       name="door"
                                       readOnly={readOnly}
                                       onChange={changeCustomerContact}
                                />
                            </LabelInput>
                        </Column>
                    </Row>
                )
            }
            <Row>
                <Column size={6}>
                    <LabelInput label="ZIP" groupAddOnIcon="fa fa-info">
                        <Input object={contact}
                               name="zip"
                               readOnly={readOnly}
                               onChange={changeCustomerContact}
                        />
                    </LabelInput>
                </Column>
                <Column size={6}>
                    <LabelInput label="City" groupAddOnIcon="fa fa-info">
                        <Input object={contact}
                               name="city"
                               readOnly={readOnly}
                               onChange={changeCustomerContact}
                        />
                    </LabelInput>
                </Column>
            </Row>
            <Row>
                <Column size={6}>
                    <LabelInput label="Country">
                        <Select
                            object={contact}
                            addEmpty={!salesOrderCustomer.countryCode}
                            name="countryCode"
                            readOnly={readOnly}
                            valueList={COUNTRY_CODE_LIST}
                            onChange={changeCustomerContact}/>
                    </LabelInput>
                </Column>
                <Column size={6}/>
            </Row>
            <Row>
                <Column size={6}>
                    <LabelInput label="Email" groupAddOnIcon="fa fa-envelope">
                        <Input object={contact}
                               name="email"
                               readOnly={readOnly}
                               onChange={changeCustomerContact}
                               onBlur={(e) => {
                                   validateEmail(e.target.value.trim())
                               }}
                        />
                        {validationMsgList.email && (<span className="form-error">{validationMsgList.email}</span>)}
                    </LabelInput>
                </Column>
                <Column size={6}>
                    <LabelInput label="Phone" groupAddOnIcon="fa fa-phone"
                                actionAddOnIcon="fa fa-phone"
                                onActionAddOnClick={() => {
                                    callNumber(salesOrderCustomer.phone)
                                }}
                    >
                        <Input object={contact}
                               readOnly={readOnly}
                               name="phone"
                               onChange={changeCustomerContact}
                        />
                    </LabelInput>
                </Column>
            </Row>
            <Row>
                <Column size={6}>
                    <LabelInput label="Year of birth" groupAddOnIcon="fa fa-child">
                        <Input object={contact} name="dob" readOnly={true}
                               onChange={()=>{}}/>
                    </LabelInput>
                </Column>
                <Column size={6}>
                </Column>
            </Row>
        </ContentBox>
    )
}

SalesOrderCustomer.propTypes = {
    salesOrderCustomer: PropTypes.object.isRequired,
    salutationList: PropTypes.array,
    changeCustomerContact: PropTypes.func.isRequired,
    saveCustomerContact: PropTypes.func.isRequired,
    callNumber: PropTypes.func.isRequired,
}

export default lifecycle({
    componentDidMount() {
        this.props.hydrateContact()
    }
})(SalesOrderCustomer)



// WEBPACK FOOTER //
// ./src/modules/sales-order/component/detail/SalesOrderCustomer.js